module.exports = __webpack_public_path__ + "static/media/scroll02_0_2x.7201d872.png";